import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "@/components/site/Hero";
import SalesPage from "@/components/site/SalesPage";
import StickyCTA from "@/components/site/StickyCTA";
import ConsentBanner from "@/components/site/ConsentBanner";
import WerteCheck from "@/pages/WerteCheck";
import { getConsent, initPixel } from "@/lib/fbpixel";

const Landing = () => (
  <>
    <Hero />
    <SalesPage />
    <StickyCTA />
  </>
);

function App() {
  useEffect(() => {
    if (getConsent() === "granted") initPixel();
  }, []);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(rafId);
      delete window.__lenis;
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/unv-werte-check" element={<WerteCheck />} />
        </Routes>
        <ConsentBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
